import { Injectable, Renderer2 } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FaviconService {
  setFavicon(renderer: Renderer2, contentServerUrl: string, faviconImage: string): void {
    if (faviconImage) {
      const linkElement = this.getLinkElement(renderer);

      if (/^https?:\/\//.test(faviconImage)) {
        renderer.setAttribute(linkElement, 'href', faviconImage);
      } else if (contentServerUrl) {
        renderer.setAttribute(linkElement, 'href', `${contentServerUrl}/${faviconImage}`);
      }
    }
  }

  private getLinkElement(renderer: Renderer2): HTMLLinkElement {
    let linkElement: HTMLLinkElement | null = null;

    try {
      linkElement = renderer.selectRootElement("link[rel*='icon']", true);
    } catch {
      // Renderer2.selectRootElement() always throws NG05104 when the element isn't found.
    }

    if (!linkElement) {
      const headElement: HTMLHeadElement = renderer.selectRootElement('head', true);
      linkElement = renderer.createElement('link') as HTMLLinkElement;

      renderer.setAttribute(linkElement, 'rel', 'icon');
      renderer.setAttribute(linkElement, 'type', 'image/x-icon');
      renderer.appendChild(headElement, linkElement);
    }

    return linkElement;
  }
}
